"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteValidator = exports.KetteValidatorKeys = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
// prettier-ignore
class KetteValidatorKeys {
}
exports.KetteValidatorKeys = KetteValidatorKeys;
KetteValidatorKeys.numGliederEvenNotValid = 'KetteNumGlieder: numGlieder: even not allowed';
KetteValidatorKeys.versatzNotNull = 'KetteVersatz: ' + 'versatz: ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.verzatzCalculationVerfahrwegFailed = 'KetteVersatz: ' + 'verfahrweg without versatz couldn\'t be calculated';
KetteValidatorKeys.verzatzGreaterVerfahrweg2 = 'KetteVersatz: ' + 'greater verfahrweg/2: ' + echain_shared_validation_1.ValidatorKeys.max;
KetteValidatorKeys.versatzNotMittig = 'KetteVersatz: ' + 'versatz is not 0 but kette is mittig';
KetteValidatorKeys.langerWegK2NotNull = 'KetteConsistency: langerWeg: k2 ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.langerWegK2NotZero = 'KetteConsistency: langerWeg: k2 is 0';
KetteValidatorKeys.langerWegGleitenderBetrieb = 'KetteConsistency: langerWeg: gleitenderBetrieb ' + echain_shared_validation_1.ValidatorKeys.truthy;
KetteValidatorKeys.einspeisungNotNull = 'KetteConsistency: einspeisung ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcNumGliederNotNull = 'KetteCalculation: numGlieder ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcTeilungNotNull = 'KetteCalculation: teilung ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcLaengeNotNull = 'KetteCalculation: laenge ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcVersatzNotNull = 'KetteCalculation: versatz ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcAELengthNotNull = 'KetteCalculation: aeLength ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcVerfahrwegNotNull = 'KetteCalculation: verfahrweg ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcKNotNull = 'KetteCalculation: k ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcK2NotNull = 'KetteCalculation: k2 ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.calcGewichtKgProMNotNull = 'KetteCalculation: gewichtKgProM ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.geschwindigkeitFLGInRange = 'KetteCalculation: geschwindigkeitFLG ' + echain_shared_validation_1.ValidatorKeys.quantityMax;
KetteValidatorKeys.beschleunigungFLGInRange = 'KetteCalculation: beschleunigungFLG ' + echain_shared_validation_1.ValidatorKeys.quantityMax;
KetteValidatorKeys.geschwindigkeitFLBInRange = 'KetteCalculation: geschwindigkeitFLB ' + echain_shared_validation_1.ValidatorKeys.quantityMax;
KetteValidatorKeys.beschleunigungFLBInRange = 'KetteCalculation: beschleunigungFLB ' + echain_shared_validation_1.ValidatorKeys.quantityMax;
KetteValidatorKeys.beschleunigungNotNull = 'KetteCalculation: beschleunigung ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.beschleunigungFLGNotNull = 'KetteCalculation: beschleunigungFLG ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.beschleunigungFLBMaxNotNull = 'KetteCalculation: beschleunigungFLBMax ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.geschwindigkeitNotNull = 'KetteCalculation: geschwindigkeit ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.geschwindigkeitFLGNotNull = 'KetteCalculation: geschwindigkeitFLG ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
KetteValidatorKeys.geschwindigkeitFLBNotNull = 'KetteCalculation: geschwindigkeitFLB ' + echain_shared_validation_1.ValidatorKeys.definedNotNull;
/**
 * The `KetteValidator` performs validations on the `Kette`.
 */
class KetteValidator {
    /**
     * Validates if numGlieder of `Kette` has to be even or odd.
     *
     * @param numGlieder The value to validate
     * @param kette The kette to validate
     * @param [keyPrefix] Prefix to be prepended to the validation key
     * @returns The validator result
     */
    static numGliederEvenOdd(numGlieder, kette, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty();
        if (numGlieder != null && kette && kette.ungeradeAnzahlGlieder) {
            v.add(echain_shared_validation_1.Validator.truthy(echain_shared_ts_utils_1.NumberUtils.toNumber(numGlieder) % 2 === 1, keyPrefix + KetteValidatorKeys.numGliederEvenNotValid));
        }
        return v;
    }
    /**
     * Validates if versatz of `Kette` is in range
     *
     * @param versatz The versatz to validate
     * @param kette The kette to validate
     * @param [keyPrefix] Prefix to be prepended to the validation key
     * @returns The validator result
     */
    static ketteVersatzInRange(versatz, kette, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty();
        if (kette.einspeisung === echain_shared_articles_1.KetteEinspeisung.aussenmittigeEinspeisung) {
            v.add(echain_shared_validation_1.Validator.definedNotNull(versatz, keyPrefix + KetteValidatorKeys.versatzNotNull));
            if (!v.hasIssues()) {
                const ketteWithoutVersatz = kette.clone();
                ketteWithoutVersatz.versatz = echain_shared_quantities_1.Length.mm(0);
                try {
                    const verfahrweg = ketteWithoutVersatz.langerWeg
                        ? echain_shared_articles_1.KetteCalculator.calcVerfahrwegWithLangerWeg(ketteWithoutVersatz.effektiveLaenge, ketteWithoutVersatz.k2, ketteWithoutVersatz.versatz)
                        : echain_shared_articles_1.KetteCalculator.calcVerfahrweg(ketteWithoutVersatz.effektiveLaenge, ketteWithoutVersatz.k, ketteWithoutVersatz.versatz);
                    v.add(echain_shared_validation_1.Validator.max(Math.abs(versatz.mm), KetteValidator.versatzMaxMM(verfahrweg), keyPrefix + KetteValidatorKeys.verzatzGreaterVerfahrweg2));
                }
                catch (e) {
                    v.add(echain_shared_validation_1.Validator.truthy(false, keyPrefix + KetteValidatorKeys.verzatzCalculationVerfahrwegFailed));
                }
            }
        }
        else if (kette.einspeisung === echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung) {
            v.add(echain_shared_validation_1.Validator.truthy(versatz ? versatz.mm === 0 : true, keyPrefix + KetteValidatorKeys.versatzNotMittig));
        }
        return v;
    }
    static langerWegConsistency(kette, keyPrefix = '') {
        if (kette.langerWeg) {
            return echain_shared_validation_1.Validation.empty().add([
                echain_shared_validation_1.Validator.truthy(kette.gleitenderBetriebErlaubt, keyPrefix + KetteValidatorKeys.langerWegGleitenderBetrieb),
                echain_shared_validation_1.Validator.definedNotNull(kette.k2, keyPrefix + KetteValidatorKeys.langerWegK2NotNull),
                echain_shared_validation_1.Validator.quantityBigger(kette.k2, 'mm', 0, keyPrefix + KetteValidatorKeys.langerWegK2NotZero),
            ]);
        }
        return echain_shared_validation_1.Validation.success();
    }
    static langerWegConsistencyJson(ketteJson, keyPrefix = '') {
        if (ketteJson.LangerWeg) {
            return echain_shared_validation_1.Validation.empty().add([
                echain_shared_validation_1.Validator.truthy(ketteJson.GleitenderBetriebErlaubt, keyPrefix + KetteValidatorKeys.langerWegGleitenderBetrieb),
                echain_shared_validation_1.Validator.definedNotNull(ketteJson.K2, keyPrefix + KetteValidatorKeys.langerWegK2NotNull),
                echain_shared_validation_1.Validator.quantityBigger(echain_shared_quantities_1.Length.fromJson(ketteJson.K2), 'mm', 0, keyPrefix + KetteValidatorKeys.langerWegK2NotZero),
            ]);
        }
        return echain_shared_validation_1.Validation.success();
    }
    static einspeisungConsistency(kette, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(kette.einspeisung, keyPrefix + KetteValidatorKeys.einspeisungNotNull),
            echain_shared_validation_1.Validator.definedNotNull(kette.versatz, keyPrefix + KetteValidatorKeys.versatzNotNull),
        ]);
        if (kette.versatz) {
            if (kette.einspeisung === echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung) {
                v.add(echain_shared_validation_1.Validator.truthy(kette.versatz.mm === 0, keyPrefix + KetteValidatorKeys.versatzNotMittig));
            }
        }
        return v;
    }
    static einspeisungConsistencyJson(ketteJson, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(ketteJson.Einspeisung, keyPrefix + KetteValidatorKeys.einspeisungNotNull),
            echain_shared_validation_1.Validator.definedNotNull(ketteJson.Versatz, keyPrefix + KetteValidatorKeys.versatzNotNull),
        ]);
        if (ketteJson.Versatz) {
            if (ketteJson.Einspeisung === echain_shared_articles_1.KetteEinspeisung.mittigeEinspeisung) {
                v.add(echain_shared_validation_1.Validator.truthy(echain_shared_quantities_1.Length.fromJson(ketteJson.Versatz).mm === 0, keyPrefix + KetteValidatorKeys.versatzNotMittig));
            }
        }
        return v;
    }
    static calcEffektiveLaengePossible(numGlieder, teilung, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(numGlieder, keyPrefix + KetteValidatorKeys.calcNumGliederNotNull),
            echain_shared_validation_1.Validator.definedNotNull(teilung, keyPrefix + KetteValidatorKeys.calcTeilungNotNull),
        ]);
    }
    static calcEffektiveLaengeWithAEPossible(numGlieder, teilung, aeLength, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(numGlieder, keyPrefix + KetteValidatorKeys.calcNumGliederNotNull),
            echain_shared_validation_1.Validator.definedNotNull(teilung, keyPrefix + KetteValidatorKeys.calcTeilungNotNull),
            echain_shared_validation_1.Validator.definedNotNull(aeLength, keyPrefix + KetteValidatorKeys.calcAELengthNotNull),
        ]);
    }
    static calcLaengePossible(verfahrweg, k, versatz, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(verfahrweg, keyPrefix + KetteValidatorKeys.calcVerfahrwegNotNull),
            echain_shared_validation_1.Validator.definedNotNull(k, keyPrefix + KetteValidatorKeys.calcKNotNull),
            echain_shared_validation_1.Validator.definedNotNull(versatz, keyPrefix + KetteValidatorKeys.calcVersatzNotNull),
        ]);
    }
    static calcLaengeWithLangerWegPossible(verfahrweg, k2, versatz, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(verfahrweg, keyPrefix + KetteValidatorKeys.calcVerfahrwegNotNull),
            echain_shared_validation_1.Validator.definedNotNull(k2, keyPrefix + KetteValidatorKeys.calcK2NotNull),
            echain_shared_validation_1.Validator.definedNotNull(versatz, keyPrefix + KetteValidatorKeys.calcVersatzNotNull),
        ]);
    }
    static calcVerfahrwegPossible(laenge, k, versatz, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(laenge, keyPrefix + KetteValidatorKeys.calcLaengeNotNull),
            echain_shared_validation_1.Validator.definedNotNull(k, keyPrefix + KetteValidatorKeys.calcKNotNull),
            echain_shared_validation_1.Validator.definedNotNull(versatz, keyPrefix + KetteValidatorKeys.calcVersatzNotNull),
        ]);
    }
    static calcVerfahrwegWithLangerWegPossible(laenge, k2, versatz, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(laenge, keyPrefix + KetteValidatorKeys.calcLaengeNotNull),
            echain_shared_validation_1.Validator.definedNotNull(k2, keyPrefix + KetteValidatorKeys.calcK2NotNull),
            echain_shared_validation_1.Validator.definedNotNull(versatz, keyPrefix + KetteValidatorKeys.calcVersatzNotNull),
        ]);
    }
    static calcNumGliederPossible(laenge, teilung, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(laenge, keyPrefix + KetteValidatorKeys.calcLaengeNotNull),
            echain_shared_validation_1.Validator.definedNotNull(teilung, keyPrefix + KetteValidatorKeys.calcTeilungNotNull),
        ]);
    }
    static calcNumGliederOddPossible(laenge, teilung, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(laenge, keyPrefix + KetteValidatorKeys.calcLaengeNotNull),
            echain_shared_validation_1.Validator.definedNotNull(teilung, keyPrefix + KetteValidatorKeys.calcTeilungNotNull),
        ]);
    }
    static calcGewichtPossible(laenge, gewichtKgProM, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(laenge, keyPrefix + KetteValidatorKeys.calcLaengeNotNull),
            echain_shared_validation_1.Validator.definedNotNull(gewichtKgProM, keyPrefix + KetteValidatorKeys.calcGewichtKgProMNotNull),
        ]);
    }
    static geschwindigkeitFLGInRange(geschwindigkeit, geschwindigkeitFLGMax, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(geschwindigkeit, keyPrefix + KetteValidatorKeys.geschwindigkeitNotNull),
            echain_shared_validation_1.Validator.definedNotNull(geschwindigkeitFLGMax, keyPrefix + KetteValidatorKeys.geschwindigkeitFLGNotNull),
            echain_shared_validation_1.Validator.quantityMax(geschwindigkeit, 'm_s', geschwindigkeitFLGMax.m_s, keyPrefix + KetteValidatorKeys.geschwindigkeitFLGInRange),
        ]);
    }
    static beschleunigungFLGInRange(beschleunigung, beschleunigungFLGMax, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(beschleunigung, keyPrefix + KetteValidatorKeys.beschleunigungNotNull),
            echain_shared_validation_1.Validator.definedNotNull(beschleunigungFLGMax, keyPrefix + KetteValidatorKeys.beschleunigungFLGNotNull),
            echain_shared_validation_1.Validator.quantityMax(beschleunigung, 'm_s2', beschleunigungFLGMax.m_s2, keyPrefix + KetteValidatorKeys.beschleunigungFLGInRange),
        ]);
    }
    static geschwindigkeitFLBInRange(geschwindigkeit, geschwindigkeitFLBMax, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(geschwindigkeit, keyPrefix + KetteValidatorKeys.geschwindigkeitNotNull),
            echain_shared_validation_1.Validator.definedNotNull(geschwindigkeitFLBMax, keyPrefix + KetteValidatorKeys.geschwindigkeitFLBNotNull),
            echain_shared_validation_1.Validator.quantityMax(geschwindigkeit, 'm_s', geschwindigkeitFLBMax.m_s, keyPrefix + KetteValidatorKeys.geschwindigkeitFLBInRange),
        ]);
    }
    static beschleunigungFLBInRange(beschleunigung, beschleunigungFLBMax, keyPrefix = '') {
        return echain_shared_validation_1.Validation.empty().add([
            echain_shared_validation_1.Validator.definedNotNull(beschleunigung, keyPrefix + KetteValidatorKeys.beschleunigungNotNull),
            echain_shared_validation_1.Validator.definedNotNull(beschleunigungFLBMax, keyPrefix + KetteValidatorKeys.beschleunigungFLBMaxNotNull),
            echain_shared_validation_1.Validator.quantityMax(beschleunigung, 'm_s2', beschleunigungFLBMax.m_s2, keyPrefix + KetteValidatorKeys.beschleunigungFLBInRange),
        ]);
    }
}
exports.KetteValidator = KetteValidator;
KetteValidator.countMin = 1;
KetteValidator.aussenbreiteGreater = 0;
KetteValidator.aussenhoeheGreater = 0;
KetteValidator.innenbreiteGreater = 0;
KetteValidator.innenhoeheGreater = 0;
KetteValidator.gewichtKgProMGreater = 0;
KetteValidator.teilungGreater = 0;
KetteValidator.numGliederGreater = 0;
KetteValidator.laengeGreater = 0;
KetteValidator.verfahrwegGreater = 0;
KetteValidator.effektiveLaengeGreater = 0;
/**
 * calculates the maximal Versatz in [mm]
 */
KetteValidator.versatzMaxMM = (verfahrweg) => {
    return verfahrweg ? Math.max(1, Math.floor(verfahrweg.mm * 0.5)) : 0;
};
/**
 * calculates the minimal Versatz [mm]
 */
KetteValidator.versatzMinMM = (verfahrweg) => {
    return verfahrweg ? Math.min(-1, Math.ceil(-verfahrweg.mm * 0.5)) : 0;
};
//# sourceMappingURL=KetteValidator.js.map